import {useEffect, useState} from "react";
import {findCouponUsagesWithPagination} from "../api/couponUsageApiClient";

export const useCouponUsages = (page, pageSize, filterCouponId) => {
    const [couponUsages, setCouponUsages] = useState([]);
    const [pagination, setPagination] = useState(null);

    useEffect(() => {
        const abortController = new AbortController();
        const couponUsagesWithPagination = findCouponUsagesWithPagination(page, pageSize, filterCouponId, abortController.signal);

        couponUsagesWithPagination
            .then(
                (data) => {
                    setCouponUsages(data.couponUsages);
                    setPagination(data.pagination);
                }
            )
            .catch(
                (error) => console.log(error)
            );

        return () => {
            abortController.abort();
        };
    }, [page, pageSize, filterCouponId]);

    return {couponUsages, pagination};
};
